var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JTPInput',{staticClass:"p-paginator-page-input",attrs:{"value":_vm.page,"disabled":_vm.disabled},on:{"input":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }